<!-- Google tag (gtag.js) -->




<ng-template #contentSenha let-modal id="contentSenha">
  <senha-form [alteracaoObrigatoria]="usuario.TrocarSenha" (alterou)="senhaAlterada($event)">
  </senha-form>
</ng-template>

<div class="header-container" [class.left]="position === 'normal'" [class.right]="position === 'inverse'">
  <div class="logo-containter">
    <a (click)="toggleSidebar()" href="#" class="navigation"><i class="nb-menu"></i></a>
    <div class="logo" (click)="goToHome()">
      <a href="#" class="">
        <img class="img-fluid" src="{{logoempresa}}" style="max-height: 50px;object-fit: cover;width: 100%;" />
      </a>
    </div>
  </div>
  <!--<select class="form-control" placeholder="Selecione o idioma" (change)="useLanguage($event.target.value)">
ption value="pt">Português</option>
ption value="en">English</option>
ption value="es">Español</option>
lect>-->
</div>

<div class="header-container">
  <ngx-layout-direction-switcher></ngx-layout-direction-switcher>

  <nb-actions size="medium" [class.right]="position === 'normal'" [class.left]="position === 'inverse'">


    <nb-action class="pl-3" *nbIsGranted="['view', 'usuario']">
      <nb-user [nbContextMenu]="userMenu" [name]="usuario?.Nome" [picture]=""></nb-user>
    </nb-action>
    <nb-action class="border-0 d-none d-md-flex">
      <h6 class="m-0 corNomeAgencia">{{NomeAgencia}}</h6>
    </nb-action>
    <nb-action class="border-0 d-none d-md-flex" *ngIf="dadoscambio">
      <h6 class="m-0 corNomeAgencia" style="margin-right:10px !important">{{'Cotações' | translate}} (
        {{dadoscambio[0]?.MoedaOrigem.Simbolo}} ): </h6>
      <h6 class="m-0 corNomeAgencia" *ngFor="let dado of dadoscambio; let i = index"
        style="margin-right:15px !important">
        {{dado.MoedaDestino.Simbolo}} :{{dado.Taxas[0]?.Taxa | currency: 'BRL':'':'1.2-2'}}
      </h6>
      <span class="m-0 corNomeAgencia" style="font-weight:regular !important;font-size: small !important;">
        {{'Atualizado em' | translate}}: {{dadoscambio[0]?.Taxas[0]?.Alteracoes.CriadoEm | date : 'dd/MM/yyyy' }}
      </span>
    </nb-action>
    <!-- <nb-action class="control-item pt-1" disabled><i class="fas fa-bell" style="font-size:20px;"></i></nb-action>
b-action class="control-item pt-1"><i class="fas fa-envelope" style="font-size:20px;"></i></nb-action>
b-action class="control-item">
<nb-search type="rotate-layout" (click)="startSearch()"></nb-search>
nb-action> -->
  </nb-actions>
</div>